<template>
  <div class="view-leads">
    <vx-card :title="$t('labels.select_consultant_service')">
      <div class="vx-row w-full m-0 mb-2">
        <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-4">
          <label class>{{ $t("labels.consultant") }}</label>
          <v-select
            v-model="consultant"
            :options="consultants"
            :reduce="(consultants) => consultants.id"
            :value="$store.myValue"
            @input="setSelectedCon"
            label="name"
            name="consultants"
          />
        </div>
        <div
          class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0 sm: p-0 md:pl-4"
        >
          <label class>{{ $t("labels.service") }}</label>
          <v-select
            v-model="service"
            :options="services_drop"
            :reduce="(services_drop) => services_drop.id"
            label="name"
            name="service"
            :value="$store.myValue"
            @input="setSelectedSer"
            :disabled="!isShowReport"
          />
        </div>
      </div>
    </vx-card>
    <div class="vx-row w-full mx-0" v-if="service">
      <div class="vx-col sm: w-full mt-6">
        <div class="vx-row">
          <div
            class="vx-col sm: w-full md:w-full label-center p-0 question-card"
          >
            <vx-card
              :title="$t('labels.executive_summary')"
              class="mb-6"
              v-if="
                selected_ser === 1 ||
                selected_ser === 2 ||
                (selected_ser === 4 && executive_summary_data)
              "
            >
              <executive-summary
                :executive-data="executive_summary_data"
                :project-id="this.$route.params.id"
                :consultant-id="selected_con"
                :service-id="selected_ser"
              ></executive-summary>
            </vx-card>
            <vx-card
              :title="$t('labels.vessel_assessment')"
              class="mb-6"
              v-if="selected_ser === 1"
            >
              <view-vessel-assessment
                :consultant-id="selected_con"
              ></view-vessel-assessment>
            </vx-card>
            <vx-card
              :title="$t('labels.general_information')"
              class="mb-6"
              v-if="selected_ser === 1"
            >
              <general-information
                :consultant-id="selected_con"
              ></general-information>
            </vx-card>
            <!-- <div class="mb-6">
              <general-images-view
                :consultant-id="selected_con"
                :service-id="selected_ser"
              ></general-images-view>
            </div> -->
            <vx-card
              :title="$t('labels.qualification_of_officers')"
              class="mb-6"
              v-if="selected_ser === 1 || selected_ser === 2"
            >
              <qualification-officers-details
                :consultant-id="selected_con"
                :service-id="selected_ser"
              ></qualification-officers-details>
            </vx-card>
            <vx-card
              :title="$t('labels.miscellaneous')"
              class="mb-6"
              v-if="
                (selected_ser === 1 ||
                  selected_ser === 2 ||
                  selected_ser === 4) &&
                executive_summary_data
              "
            >
              <view-miscellaneous
                :consultant-id="selected_con"
                :service-id="selected_ser"
              ></view-miscellaneous>
            </vx-card>
            <vx-card :title="$t('labels.inspection_image')" class="mb-6">
              <InspectionViewImage
                :project="project"
                page="viewProject"
                ref="inspectionImg"
                :sectionInfo="folderSections"
                :vesselSubTypeInfo="vesselSubTypeInfo"
              ></InspectionViewImage>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            v-show="this.service"
            class="btn-color"
            >{{ $t("labels.filter") }}</vs-button
          >
        </div>
      </div>
    </div>
    <vx-card class="filter_card mt-4" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.section") }}</label>
          <v-select
            v-model="section"
            :options="filterSection"
            :reduce="(filterSection) => filterSection.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.designation") }}</label>
          <v-select
            v-model="designation"
            :options="filterDesignation"
            :reduce="(filterDesignation) => filterDesignation.id"
            label="name"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.query_status") }}</label>
          <v-select
            v-model="query_status_filter"
            :options="filterQueryStatus"
            :reduce="(filterQueryStatus) => filterQueryStatus.value"
            label="label"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-2/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="
              !this.section &&
              !this.designation &&
              !this.query_status_filter &&
              !this.search
            "
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <!-- pagination start-->

    <div
      class="mt-6 question-pagination"
      v-if="service && question_length >= 1"
    >
      <div class="vx-row">
        <div
          class="vx-col sm: w-full md:w-1/2 sm: order-2 md:order-1 sm: mt-4 md:mt-0"
        >
          <vs-chip color="primary" class="mt-2 ml-1">
            {{ start + 1 }} -
            {{ end > question_length ? question_length : end }} of
            {{ question_length }}
          </vs-chip>
        </div>
        <div class="vx-col sm: w-full md:w-1/2 sm: order-1 md:order-2">
          <vs-pagination
            color="dark"
            :total="pageCount"
            v-model="currentx"
            class="mb-1"
          ></vs-pagination>
        </div>
      </div>
    </div>
    <!-- pagination end-->

    <div class="vx-row w-full mx-0" v-if="service">
      <div class="vx-col sm: w-full mt-6">
        <div class="vx-row mb-6">
          <div
            class="vx-col sm: w-full md:w-full label-center p-0 question-card"
          >
            <div v-for="(question, qindex) in filtered_questions" :key="qindex">
              <vx-card
                :title="
                  question.section_reference_number + ' - ' + question.question
                "
                class="mb-6"
              >
                <div
                  class="status"
                  v-if="
                    question.project_consultant_service_question.defect != null
                  "
                >
                  <label class="status-name">
                    {{
                      question.project_consultant_service_question.defect.name
                    }}
                  </label>
                </div>

                <div
                  class="vx-row mb-6"
                  v-if="
                    question.project_consultant_service_question.answer_text !=
                    null
                  "
                >
                  <div class="vx-col sm: w-auto md:w-1/6 label-center">
                    <label class="font-bold">{{ $t("labels.ans") }} :</label>
                  </div>

                  <div>
                    {{
                      question.project_consultant_service_question.answer_text
                    }}
                  </div>
                </div>

                <div
                  class="vx-row mb-6"
                  v-if="
                    question.project_consultant_service_question.answer_text !=
                    null
                  "
                >
                  <div class="vx-col sm: w-auto md:w-1/6 label-center">
                    <label class="font-bold"
                      >{{ $t("labels.is_corrected") }} :</label
                    >
                  </div>

                  <div
                    v-if="
                      question.project_consultant_service_question
                        .is_corrected === 1
                    "
                  >
                    true
                  </div>
                  <div
                    v-if="
                      question.project_consultant_service_question
                        .is_corrected === 0
                    "
                  >
                    false
                  </div>
                </div>
                <div
                  class="vx-row mb-6"
                  v-if="
                    question.project_consultant_service_question.images
                      .length !== 0
                  "
                >
                  <div
                    class="vx-col sm: w-full md:w-1/6 pr-0 sm: mb-2 label-center"
                  >
                    <label class="font-bold">{{ $t("labels.images") }} :</label>
                  </div>
                  <div
                    class="vx-col sm: w-auto md:w-auto pr-0 md:pl-0 image-size"
                    v-for="(questin_images, imageIndex) in question
                      .project_consultant_service_question.images"
                    :key="imageIndex"
                  >
                    <div v-if="questin_images.s3_url" class="mr-2 mb-4">
                      <a :href="questin_images.s3_url" target="_blank">
                        <img :src="questin_images.s3_url" alt="Image" />
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="vx-row mb-6"
                  v-if="
                    question.project_consultant_service_question
                      .answer_attachment != null
                  "
                >
                  <div class="vx-col sm: w-auto md:w-1/6 label-center">
                    <label class="font-bold"
                      >{{ $t("labels.audio_file") }} :</label
                    >
                  </div>

                  <div class="vx-row mb-6 sm: justify-center">
                    <audio controls :id="'audio_control'">
                      <source
                        :src="
                          question.project_consultant_service_question
                            .answer_attachment
                        "
                        type="audio/mpeg"
                        :id="'audio_source'"
                      />
                    </audio>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
      </div>
      <vs-popup
        class="holamundo"
        :title="$t('labels.raising_query')"
        :active.sync="popupActiveRaiseQuery"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/7">
            <vs-avatar
              :text="this.$store.state.userInfo.name"
              color="dark"
              size="40px"
              text-color="white"
            />
          </div>
          <div class="vx-col md:w-10/12">
            <vs-textarea
              type="text"
              class="w-full mb-0 mt-1"
              name="query_text"
              id="query_text"
              maxlength="5000"
              v-model="query_text"
              :placeholder="$t('labels.type_your_query')"
              icon-no-border
            />
          </div>
        </div>
        <div class="mt-6 submit-btn">
          <vs-button
            class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
            color="primary"
            :disabled="button_loading"
            id="save-answer"
            button="submit"
            @click="submitQueryText()"
            >{{ $t("labels.submit") }}</vs-button
          >
        </div>
      </vs-popup>
    </div>
    <vs-popup
      class="holamundo"
      :title="$t('labels.chat')"
      :active.sync="popupActive"
    >
      <div>
        <div class="vx-row" v-for="(comment, cindex) in comments" :key="cindex">
          <div class="vx-col w-1/7">
            <vs-avatar
              :text="comment.user.name"
              color="dark"
              size="40px"
              text-color="white"
            />
          </div>
          <div class="vx-col sm: w-8/12 md:w-10/12 label-center">
            <label class="comment-avatar">{{ comment.comment }}</label>
          </div>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-1/7">
          <vs-avatar
            :text="this.$store.state.userInfo.name"
            color="dark"
            size="40px"
            text-color="white"
          />
        </div>
        <div class="vx-col sm: w-8/12 md:w-10/12">
          <vs-textarea
            type="text"
            class="w-full mb-0 mt-1"
            name="comment"
            id="comment"
            maxlength="5000"
            v-model="comment"
            :placeholder="$t('labels.type_message')"
            icon-no-border
          />
        </div>
      </div>
      <div class="mt-6 submit-btn">
        <vs-button
          class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
          color="primary"
          :disabled="button_loading"
          id="save-answer"
          button="submit"
          @click="addProjectQuestionComments()"
          >{{ $t("labels.submit") }}</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      :title="$t('labels.raising_query')"
      :active.sync="popupActiveRaiseQuery"
    >
      <div class="vx-row">
        <div class="vx-col w-1/7">
          <vs-avatar
            :text="this.$store.state.userInfo.name"
            color="dark"
            size="40px"
            text-color="white"
          />
        </div>
        <div class="vx-col w-10/12">
          <vs-textarea
            type="text"
            class="w-full mb-0 mt-1"
            name="query_text"
            id="query_text"
            maxlength="5000"
            v-model="query_text"
            :placeholder="$t('labels.type_your_query')"
            icon-no-border
          />
        </div>
      </div>
      <div class="mt-6 submit-btn">
        <vs-button
          class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
          color="primary"
          :disabled="button_loading"
          id="save-answer"
          button="submit"
          @click="submitQueryText()"
          >{{ $t("labels.submit") }}</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ViewProject from "@/layouts/components/projects/view-project.vue";
import GeneralImageUpload from "@/layouts/components/projects/general-images-upload.vue";
import GeneralImageView from "@/layouts/components/projects/general-images-view";
import QualificationOfficersDetails from "@/layouts/components/projects/view-qualification-officers";
import ExecutiveSummary from "@/layouts/components/projects/view-executive-summary";
import ViewVesselAssessment from "@/layouts/components/projects/view-vessel-assessment";
import ViewMiscellaneous from "@/layouts/components/projects/view-miscellaneous";
import GeneralInformation from "@/layouts/components/projects/view-general-information";
import GeneralImagesView from "@/layouts/components/projects/general-images-view";
import { mapGetters } from "vuex";
import InspectionViewImage from "@/components/inspection-view-image";

export default {
  props: ["folderSections"],
  data() {
    return {
      answer_text: "",
      cancel: "",
      images: [],
      service: null,
      services_drop: [],
      consultant: "",
      consultants_drop: [],
      consultants: [],
      questions: "",
      question: [],
      consultant_services_array: [],
      question_drop: [],
      service_ids: "",
      id: this.$route.params.id,
      model: "project",
      defects: [],
      defect_id: null,
      defects_drop: [],
      selected_con: "",
      selected_ser: "",
      comments: [],
      comment: "",
      popupActive: false,
      popupActiveRaiseQuery: false,
      query_text: "",
      targeted_question_id: null,
      selected_question_index: null,
      raw_consultants: [],
      project: {},
      currentx: 1, // current page
      question_length: 0, // length of all questions
      perPage: 10, // perPage
      start: 1,
      end: 10,
      all_vessel_types: "",
      showfilter: false,
      search: "",
      designation: "",
      section_reference_number: null,
      section: 0,
      executive_summary_data: "",
      query_status_filter: "",
      filterSection: [{ name: "All Section", id: 0 }],
      filterDesignation: [{ name: "All Designation", id: "" }],
      filterQueryStatus: [
        { label: "All Query", value: "" },
        { label: "No Query", value: "N" },
        { label: "Query Reolved", value: "MR" },
        { label: "Query Raised", value: "R" },
        { label: "Query Answered", value: "A" },
      ],
      vesselSubTypeInfo: null,
    };
  },
  components: {
    GeneralImagesView,
    VueUploadMultipleImage,
    ViewProject,
    GeneralImageUpload,
    QualificationOfficersDetails,
    GeneralInformation,
    ExecutiveSummary,
    ViewVesselAssessment,
    ViewMiscellaneous,
    GeneralImageView,
    InspectionViewImage,
  },
  watch: {
    selected_con(val) {
      // if con drop is cleared than clear service and its drop
      if (!val) {
        this.service = null;
        this.services_drop = [];
      }
    },
  },
  computed: {
    ...mapGetters(["isClientRole"]),
    isShowReport() {
      return this.isClientRole
        ? ["SC", "CL"].includes(this.project.status)
        : true;
    },
    filtered_questions() {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let questions = [];
      let question = [];
      let final_answer = [];
      let that = this;
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          if (ser_target === 1) {
            that.executive_summary_data =
              el.project_consultant.safety_inspection_executive_summary_template;
          }
          if (ser_target === 2) {
            that.executive_summary_data =
              el.project_consultant.navigation_assessment_executive_summary_template;
          }
          if (ser_target === 3) {
            that.executive_summary_data =
              el.project_consultant.internal_audit_executive_summary_template;
          }
          if (ser_target === 4) {
            that.executive_summary_data =
              el.project_consultant.visit_report_executive_summary_template;
          }
          if (ser_target === 5) {
            that.executive_summary_data =
              el.project_consultant.technical_inspection_executive_summary_template;
          }
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              question = el.project_consultant_service.questions;
              question.forEach(function (item, index) {
                if (ser_target === 1) {
                  if (item.section_id !== 1) {
                    questions.push(item);
                  }
                } else {
                  questions = question;
                }
              });
              //start filter process
              if (
                that.designation ||
                that.section ||
                that.query_status_filter ||
                that.search
              ) {
                if (questions.length > 0) {
                  that.currentx = 1;
                  questions = questions.filter(function (que) {
                    let designationFlag = false;
                    let sectionFlag = false;
                    let statusFlag = false;
                    let searchFlag = false;
                    if (que.all_designations || !that.designation)
                      designationFlag = true;
                    else
                      que.designations.forEach(function (d) {
                        if (d.id == that.designation) designationFlag = true;
                      });

                    if (
                      que.section_id == that.section ||
                      que.sub_section.id == that.section ||
                      !that.section
                    )
                      sectionFlag = true;
                    if (
                      que.project_consultant_service_question.query_status ==
                        that.query_status_filter ||
                      !that.query_status_filter
                    )
                      statusFlag = true;
                    if (
                      !that.search ||
                      que.question
                        .toLowerCase()
                        .includes(that.search.toLowerCase()) ||
                      que.section_reference_number
                        .toLowerCase()
                        .includes(that.search)
                    )
                      searchFlag = true;

                    return (
                      designationFlag && sectionFlag && statusFlag && searchFlag
                    );
                  });
                }
              }
              questions.forEach(function (que) {
                // Display vessel_types guidance
                that.type_id = that.project.vessel_type_id;
                that.sub_type_id = that.project.vessel_sub_type_id;
                if (!que.all_vessel_types) {
                  let vessel_types = que.vessel_types;

                  vessel_types.forEach((element) => {
                    let que_vessel_type =
                      element.question_vessel_type.vessel_type_id;

                    if (que_vessel_type === that.type_id) {
                      let vessel_sub_types =
                        element.question_vessel_type.vessel_sub_types;

                      vessel_sub_types.forEach((ele) => {
                        let que_subvessel_type = ele.id;
                        if (que_subvessel_type === that.sub_type_id) {
                          que.guidance = element.question_vessel_type.guidance;
                          return;
                        }
                      });
                    }
                  });
                } else {
                  que.guidance = que.vessel_type_guidance;
                }
              });

              questions.forEach(function (que) {
                // Display flag guidance
                let flag_id = that.project.vessel.flag_id;
                if (!que.all_flags) {
                  let flags = que.flags;
                  flags.forEach((element) => {
                    let que_flag = element.id;

                    if (que_flag === flag_id) {
                      que.flag_text = que.flag_guidance;
                      return;
                    }
                  });
                  return;
                }
              });

              if (that.$store.state.userInfo.type === "CL") {
                questions.forEach(function (ans) {
                  let data = ans.project_consultant_service_question;
                  if (data.defect_id && data.answer_text) {
                    final_answer.push(ans);
                  }
                });
                questions = final_answer;
              }

              that.question_length = questions.length;
            }
          });
        }
      });
      /**
      Main Pagination Logic
      start = currentpage - 1 * perpage
       */
      this.start = (this.currentx - 1) * this.perPage;
      this.end = this.start + this.perPage;

      return questions.slice(this.start, this.end);
    },
    pageCount() {
      let l = this.question_length,
        s = this.perPage;
      return Math.ceil(l / s);
    },
  },
  mounted() {
    this.getProject();
    this.getDesignations();
    this.getSections();
    // this.getProjectFolderSubFolder();
  },
  methods: {
    async getProjectFolderSubFolder() {
      const projectId = this.$route.params.id;
      const response = await this.getHTTPGetResponse(
        `/projects/${projectId}/folder/subfolder/get-folders`
      );
      if (response && response.data) {
        this.folderSections = response.data.folders.map((v) => {
          return {
            ...v,
            imageUrl: v.ga_plan_image || null,
            location: v.location ? JSON.parse(v.location) : null,
            subFolders: v.subFolders.map((subFolder) => ({
              ...subFolder,
              location: subFolder.location
                ? JSON.parse(subFolder.location)
                : null,
            })),
          };
        });
      }
    },
    openPopupForRaisedQuery(id) {
      this.targeted_question_id = id;
      this.popupActiveRaiseQuery = true;
    },
    async submitQueryText() {
      let input = {
        project_consultant_service_question_id: this.targeted_question_id,
        status: "R",
        query_text: this.query_text,
      };

      let url = "/projects/change-query-status/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.popupActiveRaiseQuery = false;
        this.query_text = "";
        this.getProject();
      }
    },

    /**
     * @function setSelectedCon
     * @description this function will invoke whenever v-select of consultans changes value
     */
    setSelectedCon(value) {
      //fist clear selected service and its dropdown array
      this.service = null;
      this.services_drop = [];
      //set current v -select value as a selected_con
      this.selected_con = value;

      // get services for selected cont
      let consultants = this.raw_consultants;
      var selectedCon = consultants.filter(function (el) {
        return el.id == value;
      });
      let service_req = selectedCon[0].project_consultant.services;
      let filteredServices = [];
      for (var i = 0; i < service_req.length; i++) {
        let obj = { id: service_req[i].id, name: service_req[i].name };
        filteredServices.push(obj);
      }
      this.services_drop = filteredServices;
    },
    setSelectedSer(value) {
      this.selected_ser = value;
    },
    async sendAllData() {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let questions = [];

      consultants.forEach(function (el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              questions = el.project_consultant_service.questions;
            }
          });
        }
      });

      let input = {
        answers: [],
      };

      // let questions = this.questions;
      questions.forEach((question) => {
        let data = question.project_consultant_service_question;

        var images;
        var name = "multiple_image_" + data.id;
        if (this.$refs[name] && this.$refs[name].length) {
          images = this.$refs[name][0].images;
        } else {
          images = data.images;
        }

        var images_url = images.map((image) => {
          return image.s3_url;
        });

        var answer = {
          project_consultant_service_question_id: data.id,
          defect_id: data.defect_id,
          answer_text: data.answer_text,
          answer_attachment: data.answer_attachment,
          images: images_url,
        };

        if (answer.defect_id && answer.answer_text) {
          input.answers.push(answer);
        }
      });
      this.recordInspection(input);
    },
    async recordInspection(input) {
      let url = "/projects/inspection/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#save-answer",
        true
      );
      if (response) {
        this.getProject();
      }
    },
    async sendData(data) {
      var name = "multiple_image_" + data.id;
      var images = this.$refs[name][0].images;
      var images_url = images.map((image) => {
        return image.s3_url;
      });

      var answer = {
        project_consultant_service_question_id: data.id,
        defect_id: data.defect_id,
        answer_text: data.answer_text,
        answer_attachment: data.answer_attachment,
        images: images_url,
      };

      let input = {
        answers: [],
      };

      input.answers.push(answer);
      let url = "/projects/inspection/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#save-answer",
        true
      );
      if (response) {
        this.getProject();
      }
    },

    // API Integration for Project Question Query Status
    async getProjectChangeQueryStatus(
      project_consultant_service_question_id,
      status
    ) {
      let input = {
        project_consultant_service_question_id,
        status,
      };
      let url = "/projects/change-query-status/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.getProject();
      }
    },
    getComments(qindex) {
      this.popupActive = true;

      this.selected_question_index = qindex;
      this.comments =
        this.filtered_questions[
          qindex
        ].project_consultant_service_question.comments;
    },
    // API Integration for Project Question Comments
    async addProjectQuestionComments() {
      let input = {
        project_consultant_service_question_id:
          this.filtered_questions[this.selected_question_index]
            .project_consultant_service_question.id,
        comment: this.comment,
      };
      let url = "/projects/comment/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.comment = "";
        this.popupActive = false;
        this.getProject();
      }
    },
    // API Integration for getData
    async getProject() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/projects/get/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let project = data.project;
        this.project = data.project;
        this.vessel_type_id = project.vessel_type_id;
        this.sub_type_id = project.vessel_sub_type_id;

        this.vesselSubTypeInfo = {
          ...project.vessel_sub_type,
          ship_image_url: project.ship_url,
        };

        this.raw_consultants = project.consultants;
        let consultants = project.consultants;

        let filteredConsultants = [];
        for (var i = 0; i < consultants.length; i++) {
          let obj = { id: consultants[i].id, name: consultants[i].name };
          filteredConsultants.push(obj);
        }
        this.consultants = filteredConsultants;
        /**
        Our dear one consultant, why so many loops are here ???
         */
        if (this.consultants.length === 1) {
          this.consultant = this.consultants[0].id;
          this.selected_con = this.consultants[0].id;

          let service_req = consultants[0].project_consultant.services;
          let filteredServices = [];
          for (var i = 0; i < service_req.length; i++) {
            let obj = { id: service_req[i].id, name: service_req[i].name };
            filteredServices.push(obj);
          }
          this.services_drop = filteredServices;
        }

        // Map
        setTimeout(() => {
          let consultant_services_data = [];
          consultants.forEach((consultant) => {
            var services = consultant.project_consultant.services;
            let ser_id = [];
            services = services.forEach((serve) => {
              let squestions = serve.project_consultant_service.questions;
              squestions.forEach((que) => {});
              let obj = {
                service_name: serve.name,
                service_id: serve.id,
                service_question: squestions,
              };
              ser_id.push(obj);
            });
            consultant_services_data.push({
              consultant_id: consultant.id,
              consultant_name: consultant.name,
              services: this.service,
              work_instructions_text:
                consultant.project_consultant.work_instructions_text,
              work_instructions_attachment:
                consultant.project_consultant.work_instructions_attachment,
              status: consultant.project_consultant.status_name,
              service_ids: ser_id,
            });
          });
          this.consultant_services_array = consultant_services_data;
        }, 100);
        // Maping for images (for answers)

        project.consultants.forEach((eachCon) => {
          eachCon.project_consultant.services.forEach((eachSer) => {
            let dataQuestion = eachSer.project_consultant_service.questions.map(
              function (app) {
                if (
                  app.project_consultant_service_question.images != null &&
                  app.project_consultant_service_question.images.length != 0
                ) {
                  let images = [];
                  app.project_consultant_service_question.images.forEach(
                    (element) => {
                      if (element != null) {
                        images.push({
                          path: element,
                          s3_url: element,
                        });
                      }
                    }
                  );
                  app.project_consultant_service_question.images = images;
                } else {
                  app.project_consultant_service_question.images = [];
                }
                return app;
              }
            );
            this.questions = project.consultants;
          });
        });
      }
      this.$vs.loading.close();
    },
    // API Integration for section listing
    async getSections() {
      let input = {
        only_parents: true,
        with_children: true,
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        let filteredSection = [];
        let first_obj = { id: 0, name: "All Sections" };
        filteredSection.push(first_obj);
        for (var i = 0; i < sections.length; i++) {
          var section = sections[i];
          let obj = {
            id: sections[i].id,
            name: sections[i].id + ". " + sections[i].name,
          };
          filteredSection.push(obj);
          if (section.children.length) {
            for (var j = 0; j < section.children.length; j++) {
              var sub_type = section.children[j];
              filteredSection.push({
                id: sub_type.id,
                name: "----- " + sub_type.id + ". " + sub_type.name,
              });
            }
          }
        }
        // }
        this.filterSection = filteredSection;
      }
    },
    // API Integration for Designations
    async getDesignations() {
      let input = {
        name: this.designation,
      };
      let response = await this.getHTTPPostResponse(
        "/designations/list",
        input
      );
      if (response) {
        let designation_req = response.data.designations;
        let filteredDesignations = [];
        let first_obj = { id: "", name: "All Designation" };
        filteredDesignations.push(first_obj);
        for (var i = 0; i < designation_req.length; i++) {
          let obj = {
            id: designation_req[i].id,
            name: designation_req[i].name,
          };
          filteredDesignations.push(obj);
        }
        this.filterDesignation = filteredDesignations;
      }
    },
    clearFilter() {
      this.designation = "";
      this.section = 0;
      this.query_status_filter = "";
      this.search = "";
    },
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    clearFileName(qindex) {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              el.project_consultant_service.questions[
                qindex
              ].project_consultant_service_question.answer_attachment = "";

              let id = "audio_control_exit" + qindex;
              document.getElementById(id).load();
            }
          });
        }
      });
    },
    async handleFiles(event, qindex) {
      // var files = event.target.files;
      // $("#audio_source" + index).attr("src", URL.createObjectURL(files[0]));
      // document.getElementById("audio_control" + index).load();
      let file = event.target.files[0];
      if (file.type !== "audio/mp3") {
        event.target.files[0].value = "";
      }
      // upload s3
      var input = new FormData();
      input.append("directory", "audio_file");
      input.append("attachment", file);
      let response = await this.getHTTPPostResponse(
        "/s3/upload",
        input,
        "",
        true
      );
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              el.project_consultant_service.questions[
                qindex
              ].project_consultant_service_question.answer_attachment =
                response.data.url;

              let id = "audio_control" + qindex;
              document.getElementById(id).load();
            }
          });
        }
      });
    },
    // Images Logic
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    uploadImageSuccess(forData, index, fileList) {
      let fileImage = this.dataURLtoFile(
        fileList[index].path,
        fileList[index].name
      );
      let flag = 1;
      if (
        fileImage.type === "image/png" ||
        fileImage.type === "image/jpeg" ||
        fileImage.type === "image/jpg"
      ) {
        flag = 1;
      } else {
        alert("Please upload image with extension .png ,.jpg, .jpeg");
        flag = 0;
        let consultants = this.raw_consultants;
        let con_target = this.selected_con;
        let ser_target = this.selected_ser;
        consultants.forEach(function (el) {
          el.project_consultant.services.forEach(function (el) {
            el.project_consultant_service.questions.forEach(function (el) {
              el.project_consultant_service_question.images.splice(index, 1);
            });
          });
        });
        return false;
      }
      if (fileImage.size > 10000000) {
        alert("Please upload under 10mb!");
        let consultants = this.raw_consultants;
        let con_target = this.selected_con;
        let ser_target = this.selected_ser;
        consultants.forEach(function (el) {
          el.project_consultant.services.forEach(function (el) {
            el.project_consultant_service.questions.forEach(function (el) {
              el.project_consultant_service_question.images.splice(index, 1);
            });
          });
        });
        return false;
      } else {
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", fileImage);
        this.axios
          .post("s3/upload", input)
          .then((response) => {
            let data = response.data.data;

            fileList[index].s3_url = data.url;
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
          })
          .catch((e) => {
            this.showError(e);
          });
      }
    },
    beforeRemove(index, done, fileList) {
      this.url = fileList[index].s3_url;
      this.index = index;
      this.remove_data = {
        index: index,
        done: done,
      };
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.removeImage,
      });
    },
    removeImage() {
      let input = {
        url: this.url,
      };
      this.axios
        .post("s3/remove", input)
        .then((response) => {
          // show notification only
          // if new image is deleted.
          this.remove_data.done();
          if (!this.remove_data.edit) {
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
          }
          return "tttttt";
        })
        .catch((e) => {
          this.images.splice(this.remove_data.index, 1);
          this.remove_data.done();
          this.showError(e);
        });
    },
    goBack() {
      history.back();
    },
  },
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
.consultant-border {
  border-bottom: 2px solid #f8f8f8;
}
.question-feather {
  vertical-align: middle;
}
.label-center {
  align-self: center !important;
}
a,
a:hover {
  color: #626262;
  text-decoration: none;
}
.audio {
  -webkit-text-stroke-width: thin;
}
[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"] + label {
  background: rgba(var(--vs-dark), 1);
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Poppins", sans-serif;
  font-size: inherit;
  font-weight: 500;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  vertical-align: middle;
}
[type="file"] + label:hover {
  background-color: rgba(var(--vs-dark), 1);
}
[type="file"] + label.btn-1 {
  background-color: rgba(var(--vs-dark), 1);
  box-shadow: 0 6px #00449cd1;
  -webkit-transition: none;
  transition: none;
}
[type="file"] + label.btn-1:hover {
  box-shadow: 0 4px #00449cd1;
  top: 2px;
}
.service-border {
  border-bottom: 2px solid #f6f6f6;
}
.audio-file {
  align-items: flex-end;
}
.raise-question {
  position: absolute;
  right: 21px;
}
.comment-avatar {
  word-break: break-word;
}
.add-query {
  box-shadow: none !important;
  border: 1px solid #f1f1f1;
}
.submit-btn {
  text-align: center;
}
.header svg {
  width: 20px !important;
  height: 20px !important;
  color: rgba(var(--vs-dark), 1);
}
.external-link {
  color: rgba(var(--vs-danger), 1);
  float: left;
}
.query-text .con-vs-chip {
  float: right !important;
}
.image-size img {
  min-height: 120px;
}
</style>
